import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { LocalStorageService } from '../../services/local-storage.service';

import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class SignerService {
  static isOnlyCurrent = false;

  environment;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
  ) {
    this.environment = environment;
  }

  set(data) {
    this.localStorageService.set('signer-info', data);
  }

  get() {
    return this.localStorageService.get('signer-info');
  }

  closeSession() {
    setTimeout(() => {
      this.router.navigate(['/session-expired'], { relativeTo: this.route, skipLocationChange: true });
    }, 100);
  }

  checkExpiryDate() {
    const info = this.get();

    if (!info) {
      return false;
    }
    const expires = info['.expires'];

    if (!expires) {
      return false;
    }

    if (new Date(expires).getTime() <= new Date().getTime()) {
      return true;
    }
    return false;
  }

  finish = () => {
    this.localStorageService.remove('signer-info');
    this.router.navigate(['/finish']);
  };
}
